import { FC } from 'react';

import { PieChart } from './PieChart';
import { DaylitTheme } from '@lendica/theme';

const getUsedPercent = (totalCredit: number, available: number) => {
    if (totalCredit === 0) {
        return 100;
    }
    return Math.ceil(((totalCredit - available) * 100) / totalCredit);
};

const getAvailablePercent = (totalCredit: number, available: number) => {
    if (totalCredit === 0) {
        return 0;
    }
    return Math.floor((available * 100) / totalCredit);
};

export const UsageChart: FC<{
    total: number;
    available: number;
    color?: string;
    bgColor?: string;
}> = ({
    total,
    available,
    color = DaylitTheme.Palette.Sunrise, // '#3c41e7'
    bgColor = DaylitTheme.Palette.WarmStone, // '#ededf0'
}) => {
    // const data = useMemo(
    //     () => [
    //         {
    //             label: 'Credit Used',
    //             value: getUsedPercent(total, available),
    //             color: bgColor,
    //         },
    //         {
    //             label: 'Credit Available',
    //             value: getAvailablePercent(total, available),
    //             color: color,
    //             id: 'centered',
    //         },
    //     ],
    //     []
    // );

    const data = [
        {
            label: 'Credit Available',
            value: getAvailablePercent(total, available),
            color: color,
            id: 'centered',
        },
        {
            label: 'Credit Used',
            value: getUsedPercent(total, available),
            color: bgColor,
        },
    ];

    return <PieChart data={data} />;
};
